import config from "./config.js";
import axios from "axios";

import { ExclamationCircleOutlined, QuestionCircleOutlined } from "@ant-design/icons-vue";
import { Modal } from 'ant-design-vue';
import { createVNode, h } from 'vue';

function getProjectQueryDurationNameMap() {
  let queryDurationNames = new Map();
  queryDurationNames.set("LastThreeMonth", "三個月內 - 新增之專案");
  queryDurationNames.set("LastSixMonth", "六個月內 - 新增之專案");
  queryDurationNames.set("LastYear", "一年內 - 新增之專案");
  queryDurationNames.set("LastTwoYear", "兩年內 - 新增之專案");
  queryDurationNames.set("AllYears", "所有已新增之專案");
  return queryDurationNames;
}
export const ProjectQueryDurationNames = getProjectQueryDurationNameMap();

function getLangOptionNameMap() {
  const langOptionNameMap = new Map();
  langOptionNameMap.set("Chinese", "");
  langOptionNameMap.set("Thai", "泰文");
  langOptionNameMap.set("English", "英文");
  langOptionNameMap.set("Vietnamese", "越南文");
  langOptionNameMap.set("Indonesian", "印尼文");
  return langOptionNameMap;
}
export const LangOptionNames = getLangOptionNameMap();

function getExportActionNameMap() {
  const exportActionNameMap = new Map();
  exportActionNameMap.set("ExportXls", "匯出 Excel 97-2004 (.xls)");
  exportActionNameMap.set("ExportXlsx", "匯出 Excel (.xlsx)");
  exportActionNameMap.set("ExportPdf", "匯出 PDF 文件");
  return exportActionNameMap;
}
export const ExportActionNames = getExportActionNameMap();

function getProjectStatusNameMap() {
  const projectStatusNameMap = new Map();
  projectStatusNameMap.set("WAIT_PROCESS", "待進行");
  projectStatusNameMap.set("PROCESSING", "進行中");
  projectStatusNameMap.set("COMPLETED", "已完成");
  projectStatusNameMap.set("VOID", "作廢");
  return projectStatusNameMap;
}
export const ProjectStatusNames = getProjectStatusNameMap();

function getProjectStatusColorMap() {
  const projectStatusColorMap = new Map();
  projectStatusColorMap.set("WAIT_PROCESS", "warning");
  projectStatusColorMap.set("PROCESSING", "blue");
  projectStatusColorMap.set("COMPLETED", "green");
  projectStatusColorMap.set("VOID", "error");
  return projectStatusColorMap;
}
export const ProjectStatusColors = getProjectStatusColorMap();

function getQuestTypeNameMap() {
  const questTypeNameMap = new Map();
  questTypeNameMap.set("OVER_WORK", "過勞評估");
  questTypeNameMap.set("OVER_WORK_MIND", "過勞與心理評估");
  questTypeNameMap.set("BSRS5", "心情溫度計");
  questTypeNameMap.set("MUSCUL", "肌肉骨骼");
  questTypeNameMap.set("OVER_LOAD", "過負荷問卷");
  questTypeNameMap.set("GENERAL_PHYSICAL", "勞工一般體檢");
  questTypeNameMap.set("ELDERLY_WORK_ADAPTABILITY", "中高齡工作適能評估");
  questTypeNameMap.set("WORKPLACE_UNLAWFUL_ACTS", "職場不法侵害風險評估");
  questTypeNameMap.set("SELF_APPRAISAL_NUTRITION", "自我評核-營養");
  return questTypeNameMap;
}
export const QuestTypeNames = getQuestTypeNameMap();

function getQuestTypeColorMap() {
  const questTypeColorMap = new Map();
  questTypeColorMap.set("OVER_WORK", "red");
  questTypeColorMap.set("OVER_WORK_MIND", "geekblue");
  questTypeColorMap.set("BSRS5", "orange");
  questTypeColorMap.set("MUSCUL", "purple");
  questTypeColorMap.set("OVER_LOAD", "success");
  questTypeColorMap.set("GENERAL_PHYSICAL", "cyan");
  questTypeColorMap.set("ELDERLY_WORK_ADAPTABILITY", "processing");
  questTypeColorMap.set("WORKPLACE_UNLAWFUL_ACTS", "magenta");
  questTypeColorMap.set("SELF_APPRAISAL_NUTRITION", "volcano");
  return questTypeColorMap;
}
export const QuestTypeColors = getQuestTypeColorMap();

export default {
  saveAuthorizedQuestTypes: function(authorizedQuestTypes) {
    localStorage.setItem("mgmt-health-authorized-quest-types", authorizedQuestTypes);
  },
  getAuthorizedQuestTypes: function() {
    let authorizedQuestTypes = localStorage.getItem("mgmt-health-authorized-quest-types");
    if (authorizedQuestTypes == null) {
      return new Array();
    }
    return authorizedQuestTypes.split(',');
  },
  getAuthorizedQuestTypeFilter: function() {
    let authorizedQuestTypes = this.getAuthorizedQuestTypes();
    if (authorizedQuestTypes == null || authorizedQuestTypes.length === 0) {
      return new Array();
    }
    let authorizedQuestTypeFilter = new Array(authorizedQuestTypes.length);
    authorizedQuestTypes.forEach(authorizedQuestType => {
      authorizedQuestTypeFilter.push({
        text: QuestTypeNames.get(authorizedQuestType),
        value: authorizedQuestType
      });
    });
    return authorizedQuestTypeFilter;
  },
  saveQueryDuration: function(queryDuration) {
    localStorage.setItem("mgmt-health-query-duration", queryDuration);
  },
  getQueryDuration: function(defaultQueryDuration) {
    let queryDuration = localStorage.getItem("mgmt-health-query-duration");
    if (queryDuration == null) {
      return defaultQueryDuration;
    }
    return queryDuration;
  },
  authToken: function(otp, successCallback, failCallback) {
    const storageToken = localStorage.getItem("mgmt-health-token");
    if (otp != null) {
      console.log("[Vue-Router] Fetch Token by OTP.", otp);
      this.fetchToken(otp, (token) => {
        console.log("[Vue-Router] Get token success from API Service with length.", token.length);
        localStorage.setItem("mgmt-health-token", token);
        successCallback();
      }, () => {
        localStorage.removeItem("mgmt-health-token");
        failCallback();
      });
    } else if (storageToken != null) {
      this.validateToken(storageToken, (userContext) => {
        console.log("[Vue-Router] Valid Token successfully by user: " + 
          userContext.username + " and expiration: " + userContext.expiration);
        successCallback();
      }, () => {
        localStorage.removeItem("mgmt-health-token");
        failCallback();
      });
    } else {
      failCallback();
    }
  },
  removeToken: function(successCallback) {
    localStorage.removeItem("mgmt-health-token");
    if (successCallback) {
      successCallback();
    }
  },
  getTextLength: function(text) {
    var size = text.length;
    var len = 0;
    for (var i = 0 ; i < size ; i++) {
      var charCode = text.charCodeAt(i);
      while( charCode > 0 ){
          len++;
          charCode = charCode >> 8;
      }
    }
    return len;
  },
  fetchToken: function (otp, success, failure) {
    axios
      .get(config.otpAuthContextPath + otp)
      .then((response) => {
        const token = response.data.token;
        if (token !== undefined) {
          success(token);
        } else {
          console.error("Error: Auth OTP failure with URL: " + config.otpAuthContextPath + otp);
          if (failure) {
            failure();
          }
        }
      })
      .catch((error) => {
        console.error("Error fetch token: ", error);
        if (failure) {
          failure(error);
        }
      });
  },
  validateToken: function (token, success, failure) {
    axios
      .get(config.tokenAuthContextPath + token)
      .then((response) => {
        const userContext = response.data.context;
        if (userContext !== undefined) {
          success(userContext);
        } else {
          console.error("Error: Auth Token failure with URL: " + config.tokenAuthContextPath + token);
          if (failure) {
            failure();
          }
        }
      })
      .catch((error) => {
        console.error("Error validate token: ", error);
        if (failure) {
          failure(error);
        }
      });
  },
  postRequest: function (requestPath, requestBody, success, failure, errorModalWidth = 800) {
    axios.post(requestPath, requestBody, {
      headers: {
        "REQ-TOKEN": localStorage.getItem("mgmt-health-token")
      }
    })
    .then((response) => success(response))
    .catch((error) => {
      console.error("[Post-Request] Failed by RequestPath, RequestBody and Error.", requestPath, requestBody, error);
      if (error.response != null && error.response.status === 401) {
        this.openErrorModal(500, "身份過期", "認證身份已過期，請重新登入！");
      } else if (error.response != null) {
        this.openSystemErrorModal(errorModalWidth, "系統錯誤", "訊息：「" + error.response.data + "」");
      }
      if (failure) {
        failure(error);
      }
    });
  },
  postRequestWithPromise: function (requestPath, requestBody) {
    return axios.post(requestPath, requestBody, {
      headers: {
        "REQ-TOKEN": localStorage.getItem("mgmt-health-token")
      }
    });
  },
  postFormDataRequest: function(requestPath, formData, success, failure) {
    axios.post(requestPath, formData, {
      headers: {
        "REQ-TOKEN": localStorage.getItem("mgmt-health-token"),
        "Content-Type": "multipart/form-data"
      }
    })
    .then((response) => success(response))
    .catch((error) => {
      console.error("Error Sending Post request: ", error);
      if (failure) {
        failure(error);
      }
    });
  },
  getRequest: function(requestPath, success, failure) {
    axios.get(requestPath, {
      headers: {
        "REQ-TOKEN": localStorage.getItem("mgmt-health-token")
      }
    })
    .then((response) => success(response))
    .catch((error) => {
      console.error("[Get-Request] Failed by RequestPath and Error.", requestPath, error);
      if (error.response != null && error.response.status === 401) {
        this.openErrorModal(500, "身份過期", "認證身份已過期，請重新登入！");
      } else if (error.response != null) {
        this.openSystemErrorModal(800, "系統錯誤", "訊息：「" + error.response.data + "」");
      }
      if (failure) {
        failure(error);
      }
    });
  },
  downloadFileByPosting: function(requestPath, fileName, requestBody, success, failure, noContent) {
    axios.post(requestPath, requestBody, {
      headers: {
        "REQ-TOKEN": localStorage.getItem("mgmt-health-token")
      },
      responseType: 'blob'
    }).then((response) => {
      if (response.status == 204) {
        if (noContent) {
          noContent(fileName);
        }
        return ;
      }
      const url = URL.createObjectURL(response.data);
      const anchor = document.createElement('a');
      anchor.href = url;
      anchor.download = fileName;
      anchor.style.display = 'none';
      document.body.appendChild(anchor);
      anchor.click();
      anchor.remove();
      URL.revokeObjectURL(url);
      if (success) {
        success(response);
      }
    }).catch((error) => {
      console.error("Error Download File: " + error);
      if (failure) {
        failure(error);
      }
    });
  },
  downloadFile: function(requestPath, fileName, success, failure, noContent) {
    axios.get(requestPath, {
      headers: {
        "REQ-TOKEN": localStorage.getItem("mgmt-health-token")
      },
      responseType: 'blob'
    }).then((response) => {
      if (response.status == 204) {
        if (noContent) {
          noContent(fileName);
        }
        return ;
      }
      const url = URL.createObjectURL(response.data);
      const anchor = document.createElement('a');
      anchor.href = url;
      anchor.download = fileName;
      anchor.style.display = 'none';
      document.body.appendChild(anchor);
      anchor.click();
      anchor.remove();
      URL.revokeObjectURL(url);
      if (success) {
        success(response);
      }
    }).catch((error) => {
      console.error("Error Download File: " + error);
      if (failure) {
        failure(error);
      }
    });
  }, 
  openInfoModal: function(title, message) {
    Modal.info({
      title: title,
      width: '500px',
      icon: createVNode(ExclamationCircleOutlined),
      content: h(
        'div', { style: 'white-space: pre; top: 20px;' }, message
      ),
      okText: "關閉"
    });
  }, 
  openConfirmModalByActions: function(modalWidth, title, message, confirmAction, cancelAction) {
    Modal.confirm({
      title: title,
      width: modalWidth + 'px',
      icon: createVNode(QuestionCircleOutlined),
      okText: "確認",
      cancelText: "取消",
      content:  h(
        'div', { style: 'white-space: pre; top: 20px;' }, message
      ), onOk() {
        if (confirmAction) {
          confirmAction();
        }
      },
      onCancel() {
        if (cancelAction) {
          cancelAction();
        }
      },
    });
  },
  openConfirmModal: function(modalWidth, title, message, confirmActionPromise) {
    Modal.confirm({
      title: title,
      width: modalWidth + 'px',
      icon: createVNode(QuestionCircleOutlined),
      okText: "確認",
      cancelText: "取消",
      content:  h(
        'div', { style: 'white-space: pre; top: 20px;' }, message
      ), async onOk() {
        return await new Promise((resolve) => {
          confirmActionPromise()
            .then(resolve)
            .catch(() => {
              resolve();
             });
        });
      },
      onCancel() {},
    });
  },
  openSystemErrorModal: function(modalWidth, title, message) {
    Modal.error({
      title: title,
      width: modalWidth + "px",
      content: message,
      okText: "關閉"
    });
  },
  openErrorModal: function(modalWidth, title, message) {
    Modal.error({
      title: title,
      width: modalWidth + "px",
      content: h(
        'div', { style: 'white-space: pre; top: 20px;' },message
      ),
      okText: "關閉"
    });
  },
  isEmpty: function(inputValue) {
    if (inputValue === undefined || inputValue === null) {
        return true;
    }
    return ('' + inputValue).length === 0;
  }, 
  isNotEmpty: function(inputValue) {
    return !this.isEmpty(inputValue);
  },
  getDisplayPersonalNo: function(inputValue) {
    if (this.isValidUuid(inputValue)) {
      return "未提供";
    }
    return inputValue;
  },
  isValidUuid: function(uuid) {
    const regex = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$/;
    return regex.test(uuid);
  }
};
